<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs :title="$t('companyPage.irkt')" />
      <div
        v-if="resultCompany"
        class="row "
      >
        <div class="col-xl-4 ">
          <div class="card">
            <div class="card-body">
              <div class="text-center">
                <input
                  id="fileInput"
                  ref="file"
                  type="file"
                  style="display: none"
                  @change="setPhoto"
                >
                <img
                  :src="getPhoto(resultCompany.logo,'thumbnailCropped')"
                  class="img-thumbnail rounded-circle mb-3"
                  alt="companyLogo"
                  style="width: 200px;"
                  @click="selectPhoto"
                >
                <button
                  class="btn btn-sm mr-2 btn-outline-primary px-2"
                  @click="selectPhoto"
                >
                  <feather
                    type="upload"
                    size="16"
                  />
                </button>
                <h3>
                  {{ resultCompany.name }} {{ getCompanyFormat(resultCompany.format) }}
                </h3>
                <p class="lead">
                  {{ resultCompany.taxId }}
                </p>

                <p class="text-gray">
                  {{ resultCompany.address }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-8 ">
          <div
            v-if="showCreateForm"
            class="card"
          >
            <div class="card-body">
              <p class="lead">
                {{ $t('companyPage.yeniProfil') }}
              </p>

              <p class="text-danger">
                {{ $t('companyPage.daxilEdiyinizMlumatlar') }} <strong>{{ resultCompany.name }}
                  {{ getCompanyFormat(resultCompany.format) }}</strong> {{ $t('companyPage.n') }}
                <strong>{{ getProfileName(activeProfile) }}</strong>
                {{ $t('companyPage.istiqamtiZrLaqMlumatlardrVHrKsNAqOlacaq') }}
              </p>

              <form @submit.prevent="createProfile">
                <div class="row">
                  <div class="col-6 mb-3">
                    <label>{{ $t('companyPage.telefon') }}</label>
                    <input
                      v-model="phoneNumber"
                      type="tel"
                      class="form-control"
                      required
                    >
                  </div>
                  <div class="col-6 mb-3">
                    <label>E-mail *</label>
                    <input
                      v-model="email"
                      type="email"
                      class="form-control"
                      required
                    >
                  </div>
                  <div class="col-6 mb-3">
                    <label>{{ $t('companyPage.websayt') }}</label>
                    <input
                      v-model="website"
                      type="text"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="mb-3">
                  <label>{{ $t('companyPage.vzifniz') }}</label>
                  <input
                    v-model="profilePosition"
                    type="text"
                    class="form-control"
                    required
                  >
                </div>


                <div class="mb-3">
                  <button
                    type="submit"
                    class="btn btn-primary mb-2"
                  >
                    {{ $t('changeAccount.profilYarat') }}
                  </button>
                  <br>
                  <a
                    class="text-primary "
                    @click.prevent="showCreateForm = false"
                  >
                    {{ $t('companyPage.baqaProfilSe') }}
                  </a>
                </div>
              </form>
            </div>
          </div>
          <div v-else>
            <div class="card">
              <div class="card-body">
                <div class=" lead">
                  {{ $t('companyPage.yalnizBirFaliyytYnnSeBilrsizBuHaldaPortaldaBtnFunk') }}
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-md-6">
                <div class="card">
                  <div
                    class="card-body lead d-flex align-items-center"
                    style="cursor: pointer"
                    @click="openProfileForm('PROCUREMENT')"
                  >
                    <img
                      src="../../../assets/images/icons/procurement.png"
                      alt=""
                      class="mr-3"
                      style="height: 30px;"
                    >
                    {{ $t('companyPage.satnalma') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div
                    class="card-body lead d-flex align-items-center"
                    style="cursor: pointer"
                    @click="openProfileForm('SUPPLIER')"
                  >
                    <img
                      src="../../../assets/images/icons/supplier.png"
                      alt=""
                      class="mr-3"
                      style="height: 30px;"
                    >
                    {{ $t('companyPage.tdark') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div
                    class="card-body lead d-flex align-items-center"
                    style="cursor: pointer"
                    @click="openProfileForm('LOGISTIC')"
                  >
                    <img
                      src="../../../assets/images/icons/truck.png"
                      alt=""
                      class="mr-3"
                      style="height: 30px;"
                    >
                    {{ $t('companyPage.logistika') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div
                    class="card-body lead d-flex align-items-center"
                    style="cursor: pointer"
                    @click="openProfileForm('TRUCK')"
                  >
                    <img
                      src="../../../assets/images/icons/truck.png"
                      alt=""
                      class="mr-3"
                      style="height: 30px;"
                    >
                    {{ $t('companyPage.trSahibi') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  applyCompanyProfile,
  createProfile,
  getCompanyById,
  getCompanyProfile,
  updateCompanyLogoById,
  upload,
  userSetAccount
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";


export default {
  data() {
    return {
      mediaBase: mediaBase,
      sectors: [],
      legalForm: '',
      taxId: '',
      resultCompany: null,
      showCreateForm: false,
      companyName: '',
      companyFormat: '',
      selectedSectors: [],
      activeProfile: '',
      phoneNumber: '',
      email: '',
      website: '',
      profilePosition: ''
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),
  },
  mounted() {
    this.getCompany();
    this.phoneNumber = this.user.phone;
    this.email = this.user.email;
  },
  methods: {
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },

    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    selectPhoto() {
      window.document.getElementById('fileInput').click();

    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'profilePhoto', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {
                //TODO LANGUAGE
                updateCompanyLogoById(this.token, response.data.path, this.$route.params['id']).then(data => {
                  if (data.code === 200) {
                    this.getCompany();
                  } else {
                    this.$swal({
                      title: `Error ${data.code}`,
                      text: `${data.message}`,
                      icon: 'error'
                    })
                  }
                })

              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {

              this.progress = 0;
              this.$swal({
                title: `Error `,
                text: this.$t("request.cldNotUploadFile") + e,
                icon: 'error'
              })
            });

      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("request.photoUploadNotSpprtdBrowser"),
          icon: 'error'
        })
      }
    },
    openProfileForm(profileType) {

      this.activeProfile = profileType;
      //TODO LANGUAGE
      getCompanyProfile(this.token, this.$route.params['id'], profileType).then(data => {
        if (data.code === 200) {
          this.$swal({
            title: this.$t("dashboardActiveCompanyCard.vezife"),
            input: 'text',
            icon: 'question'
          }).then((result) => {


            if (result.value) {
              applyCompanyProfile(this.token, this.resultCompany.id, profileType, result.value).then(data => {
                if (data.code === 200) {

                  userSetAccount(this.token, this.resultCompany.id, profileType, 'company').then(data => {
                    if (data.code === 200) {

                      this.$router.replace({name: 'welcome'});

                    } else {
                      this.$swal({
                        title: `Error ${data.code}`,
                        text: `${data.message}`,
                        icon: 'error'
                      })
                    }
                  })

                } else if (data.code === 409) {

                  this.$swal({
                    title: this.$t("err"),
                    text: "Sizin bu şirkətdə eyni adda profiliniz var!",
                    icon: 'error'
                  })
                } else {
                  this.$swal({
                    title: `Error ${data.code}`,
                    text: `${data.message}`,
                    icon: 'error'
                  })
                }
              })
            }

          })

        } else if (data.code === 404) {
          this.showCreateForm = true;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })

    },
    //TODO LANGUAGE
    getCompany() {
      getCompanyById(this.token, this.$route.params['id']).then(data => {
        if (data.code === 200) {
          this.resultCompany = data.company;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            this.$router.push({name: 'dashboard'})
          })
        }
      })
    },
    createProfile() {
      let data = {
        phone: this.phoneNumber,
        email: this.email,
        website: this.website,
        linkedin: ''
      };

      createProfile(this.token, this.resultCompany.id, JSON.stringify(data), this.activeProfile, this.profilePosition).then(data => {
        if (data.code === 200) {
          //TODO LANGUAGE
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text: this.$t("companyPage.createdSuccessfully"),
            icon: 'success'
          }).then(() => {
            userSetAccount(this.token, this.resultCompany.id, this.activeProfile, 'company').then(data => {
              if (data.code === 200) {
                this.$router.replace({name: 'welcome'});
              } else {
                if (data.code === 409) {
                  //TODO LANGUAGE
                  this.$swal({
                    title: `Error `,
                    text: this.$t("companyPage.alreadyCreated"),
                    icon: 'error'
                  });
                } else {
                  this.$swal({
                    title: `Error ${data.code}`,
                    text: `${data.message}`,
                    icon: 'error'
                  })
                }
              }
            });
          });

        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    }
  }


}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
